import styled from 'styled-components';

export const DashboardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm, 16px);
`;
